export default "__VITE_ASSET__fcc98850__"